export default __webpack_public_path__ + "static/media/shoppinglist_card_1@2x.4030acb1.png";